
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.957 1.604L11.25.896.896 11.25 11.25 21.604l.707-.708-9.646-9.646z"}})])
          )
        }
      }
    